import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IExceptionModel } from '../../../models/index';
import { DeleteExceptionPayload, EditExceptionPayload, UpdateExceptionPayload } from '../../actions/types/exceptions/ExceptionTypes';

interface IExceptionInitialState {
  exceptions: IExceptionModel[],
  importedInvalidExceptions: string[],
  pageNo: number
}

const initialState: IExceptionInitialState = {
  exceptions: [],
  importedInvalidExceptions: [],
  pageNo: 0,
};

const ExceptionDetailsSlice = createSlice({
  name: 'exceptionDetails',
  initialState,
  reducers: {
    addException: (state, action: PayloadAction<IExceptionModel>) => {
      state.exceptions.unshift({ ...action.payload });
    },
    addAllException: (state, action: PayloadAction<IExceptionModel[]>) => {
      state.exceptions = [...action.payload];
    },

    editException: (state, actions: PayloadAction<EditExceptionPayload>) => {
      state.exceptions.forEach((exception) => {
        if (exception.id === actions.payload.index) {
          exception.isEdit = true;
        } else {
          exception.isEdit = false;
        }
        return exception.isEdit;
      });
    },

    closeEditException: (state) => {
      state.exceptions.forEach((exception) => {
        exception.isEdit = false;
      });
    },

    updateException: (state, actions: PayloadAction<UpdateExceptionPayload>) => {
      const index = state.exceptions.findIndex((exception) => exception.id === actions.payload.index);
      state.exceptions.splice(index, 1, actions.payload.exception);
    },

    updatePageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },

    deleteException: (state, actions: PayloadAction<DeleteExceptionPayload>) => {
      const index = state.exceptions.findIndex((exception) => exception.id === actions.payload.index);
      state.exceptions.splice(index, 1);
    },

    clearAllExceptions: (state) => {
      state.exceptions = initialState.exceptions;
      state.pageNo = initialState.pageNo;
      state.importedInvalidExceptions = initialState.importedInvalidExceptions;
    },

    addImportedExceptions: (state, action: PayloadAction<IExceptionModel[]>) => {
      state.exceptions.push(...action.payload);
    },

    addInvalidExceptions: (state, action: PayloadAction<string[]>) => {
      state.importedInvalidExceptions.push(...action.payload);
    },

    clearInvalidExceptions: (state) => {
      state.importedInvalidExceptions = [];
    }

  }
});

export const {
  addException,
  deleteException,
  updateException,
  addAllException,
  editException,
  clearAllExceptions,
  updatePageNo,
  closeEditException,
  addImportedExceptions,
  addInvalidExceptions,
  clearInvalidExceptions
} = ExceptionDetailsSlice.actions;
export default ExceptionDetailsSlice.reducer;
